import React from "react";
import * as PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {withStyles} from '@material-ui/core/styles';
import HeatExchangerCleaningRangeTableRow from "./HeatExchangerCleaningRangeTableRow";
import PlantManagementUtility from "./PlantManagementUtility";
import Utility from "../../Utility";

const styles = theme => ({
    tableTitle: {
        width: theme.spacing.unit,
        padding: theme.spacing.unit / 2,
        fontSize: '1rem',
    },
    tableHeaderTop: {
        borderColor: 'white',
        borderStyle: 'solid',
        backgroundColor: 'skyblue',
        padding: 0,
        textAlign: 'center',
        fontSize: '1rem',
    },
});

const tableHeaderNoLabelLeftStyle = {
    border: 4,
    width: 8,
    padding: 0,
};

const tableHeaderLeftStyle = {
    border: 4,
    borderColor: 'white',
    borderStyle: 'solid',
    backgroundColor: 'skyblue',
    width: 8,
    padding: 0,
    fontSize: '1rem',
};

const ROWS = [
    {
        cleaningRangeType: PlantManagementUtility.CLEANING_RANGE_TYPE.INNER,
        paramMapKey: PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_GAN1,
        noSpecification: true,
        noNozzle: true,
        children: <TableCell component="th" rowSpan={4} style={tableHeaderLeftStyle} align={'center'}>内面</TableCell>,
    },
    {
        cleaningRangeType: PlantManagementUtility.CLEANING_RANGE_TYPE.INNER,
        paramMapKey: PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_FLEXI1,
        specificationOption: PlantManagementUtility.OPTION_SPECIFICATION_INNER_FLEXI
    },
    {
        cleaningRangeType: PlantManagementUtility.CLEANING_RANGE_TYPE.INNER,
        paramMapKey: PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_EQUIPMENT1,
        specificationOption: PlantManagementUtility.OPTION_SPECIFICATION_INNER_EQUIPMENT
    },
    {
        cleaningRangeType: PlantManagementUtility.CLEANING_RANGE_TYPE.INNER,
        paramMapKey: PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_LANCE1,
        specificationOption: PlantManagementUtility.OPTION_SPECIFICATION_INNER_LANCE
    },
    {
        cleaningRangeType: PlantManagementUtility.CLEANING_RANGE_TYPE.OUTER,
        paramMapKey: PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_GAN1,
        noNozzle: true,
        specificationOption: PlantManagementUtility.OPTION_SPECIFICATION_OUTER_GAN,
        children: <TableCell component="th" rowSpan={2} style={tableHeaderLeftStyle} align={'center'}>外面</TableCell>
    },
    {
        cleaningRangeType: PlantManagementUtility.CLEANING_RANGE_TYPE.OUTER,
        paramMapKey: PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_EQUIPMENT1,
        noNozzle: true,
        specificationOption: PlantManagementUtility.OPTION_SPECIFICATION_OUTER_EQUIPMENT
    },
    {
        cleaningRangeType: PlantManagementUtility.CLEANING_RANGE_TYPE.SUPER_HIGH,
        paramMapKey: PlantManagementUtility.CONSTRUCTION_METHOD_KEY.SUPER_HIGH_NUM1,
        isSpecificationTextField: true,
        noPressure: true,
        children: <TableCell component="th" style={tableHeaderLeftStyle} align={'center'}>超高</TableCell>
    }
];

class HeatExchangerCleaningRange extends React.Component {
    constructor(props) {
        super(props);
        this.change = this.change.bind(this);
        this.onChangeConstructionMethod = this.onChangeConstructionMethod.bind(this);
        this.onChangeSpecification = this.onChangeSpecification.bind(this);
        this.onChangeNozzle = this.onChangeNozzle.bind(this);
        this.onChangePressure = this.onChangePressure.bind(this);
        this.onChangeStart = this.onChangeStart.bind(this);
        this.onChangeStop = this.onChangeStop.bind(this);
        this.onChangeComplete = this.onChangeComplete.bind(this);
        this.onChangeAdditionalReason = this.onChangeAdditionalReason.bind(this);
    }

    change(paramName, value) {
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);
        newHeatExchanger[paramName] = value;
        newHeatExchanger.systemInfoUpdateDate = Utility.getNowDatetimeString();

        this.props.onChangeHeatExchanger(newHeatExchanger);
    }

    onChangeConstructionMethod(event, props) {
        let paramMap = PlantManagementUtility.CLEANING_RANGE_MAP.get(props.paramMapKey);
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);
        newHeatExchanger.systemInfoUpdateDate = Utility.getNowDatetimeString();
        if (event.target.checked) {
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD)] = PlantManagementUtility.CONSTRUCTION_METHOD_LABEL_MAP.get(props.paramMapKey);

            switch (props.cleaningRangeType) {
                case PlantManagementUtility.CLEANING_RANGE_TYPE.INNER:
                    // 「洗浄範囲(予定)」の「内面Mpa」が'○'でない && 「洗浄範囲(実績)」の「圧力」が未設定の場合,「洗浄範囲(予定)」の「内面Mpa」の値を圧力に設定する.
                    if (!PlantManagementUtility.isParamTrue(this.props.heatExchanger.planOfCrInternalMpa) && this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE)] === '') {
                        newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE)] = this.props.heatExchanger.planOfCrInternalMpa;
                    }
                    break;
                case PlantManagementUtility.CLEANING_RANGE_TYPE.OUTER:
                    // 「洗浄範囲(予定)」の「外面Mpa」が'○'でない && 「洗浄範囲(実績)」の「圧力」が未設定の場合,「洗浄範囲(予定)」の「外面Mpa」の値を圧力に設定する.
                    if (!PlantManagementUtility.isParamTrue(this.props.heatExchanger.planOfCrExternalMpa) && this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE)] === '') {
                        newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE)] = this.props.heatExchanger.planOfCrExternalMpa;
                    }
                    break;
                case PlantManagementUtility.CLEANING_RANGE_TYPE.SUPER_HIGH:
                    // 「洗浄範囲(予定)」の「超高」が'○'でない && 「洗浄範囲(実績)」の「仕様」が未設定の場合,「洗浄範囲(予定)」の「超高」の値を仕様に設定する.
                    if (!PlantManagementUtility.isParamTrue(this.props.heatExchanger.planOfCrSuperHigh) && this.props.heatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION)] === '') {
                        newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION)] = this.props.heatExchanger.planOfCrSuperHigh;
                    }
                    break;
                default:
                    break;
            }
        } else {
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON)] = '';
        }

        this.props.onChangeHeatExchanger(newHeatExchanger);
    }

    onChangeSpecification(event, props) {
        let paramMap = PlantManagementUtility.CLEANING_RANGE_MAP.get(props.paramMapKey);
        this.change(paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION), event.target.value);
    }

    onChangeNozzle(event, props) {
        let paramMap = PlantManagementUtility.CLEANING_RANGE_MAP.get(props.paramMapKey);
        this.change(paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE), event.target.value);
    }

    onChangePressure(event, props) {
        let paramMap = PlantManagementUtility.CLEANING_RANGE_MAP.get(props.paramMapKey);
        this.change(paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE), event.target.value);
    }

    onChangeStart(event, props) {
        // 開始はONのみ可能.
        if (event.target.checked) {
            let paramMap = PlantManagementUtility.CLEANING_RANGE_MAP.get(props.paramMapKey);
            let nowDatetimeString = Utility.getNowDatetimeString();
            let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START)] = PlantManagementUtility.PARAM_BOOL.TRUE;
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME)] = nowDatetimeString;
            newHeatExchanger.systemInfoUpdateDate = nowDatetimeString;

            this.props.onChangeHeatExchanger(newHeatExchanger);
        }
    }

    onChangeStop(event, props) {
        let paramMap = PlantManagementUtility.CLEANING_RANGE_MAP.get(props.paramMapKey);
        let nowDatetimeString = Utility.getNowDatetimeString();
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);
        newHeatExchanger.systemInfoUpdateDate = nowDatetimeString;

        if (event.target.checked) {
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP)] = PlantManagementUtility.PARAM_BOOL.TRUE;
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME)] = nowDatetimeString;
        } else {
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP)] = PlantManagementUtility.PARAM_BOOL.FALSE;
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE)] = this.getStopCumulativeMinuteString(
                newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE)],
                newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME)]
            );
        }

        this.props.onChangeHeatExchanger(newHeatExchanger);
    }

    getStopCumulativeMinuteString(baseStopCumulativeMinute, stopDatetime) {
        let cumulativeMinute = PlantManagementUtility.parseInt(baseStopCumulativeMinute);

        // 停止スタートから停止解除までの時間(分)を算出.
        let diffMinute = PlantManagementUtility.getDiffMinuteFromNow(stopDatetime);

        return (cumulativeMinute + diffMinute).toString();
    }

    getWorkCumulativeMinuteString(stopCumulativeMinute, startDatetime) {
        let parsedStopCumulativeMinute = PlantManagementUtility.parseInt(stopCumulativeMinute);

        // 開始(日時)から現在までの時間(分)を算出.
        let diffMinute = PlantManagementUtility.getDiffMinuteFromNow(startDatetime);

        return (diffMinute - parsedStopCumulativeMinute).toString();
    }

    onChangeComplete(event, props) {
        let paramMap = PlantManagementUtility.CLEANING_RANGE_MAP.get(props.paramMapKey);
        let nowDatetimeString = Utility.getNowDatetimeString();
        let newHeatExchanger = Utility.getDeepCopy(this.props.heatExchanger);

        newHeatExchanger.systemInfoUpdateDate = nowDatetimeString;
        if (event.target.checked) {
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE)] = PlantManagementUtility.PARAM_BOOL.TRUE;
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME)] = nowDatetimeString;
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE)] = this.getWorkCumulativeMinuteString(
                newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE)],
                newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME)]
            );
        } else {
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE)] = PlantManagementUtility.PARAM_BOOL.FALSE;
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME)] = '';
            newHeatExchanger[paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE)] = '0'; // Androidアプリのソースコードにて"0"を設定している.
        }

        this.props.onChangeHeatExchanger(newHeatExchanger);
    }

    onChangeAdditionalReason(event, props) {
        let paramMap = PlantManagementUtility.CLEANING_RANGE_MAP.get(props.paramMapKey);
        this.change(paramMap.get(PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON), event.target.value);
    }

    render() {
        return (
            <Table size={'small'}>
                <TableBody>
                    <TableRow align={'center'} style={{height: 24}}>
                        <TableCell size={'small'} rowSpan={ROWS.length + 1} className={this.props.classes.tableTitle} align={'center'}>{'洗浄範囲'}</TableCell>
                        <TableCell style={tableHeaderNoLabelLeftStyle}/>
                        <TableCell align={"center"} className={this.props.classes.tableHeaderTop} style={{width: 140}}>工法</TableCell>
                        <TableCell align={"center"} className={this.props.classes.tableHeaderTop} style={{width: 120}}>仕様</TableCell>
                        <TableCell align={"center"} className={this.props.classes.tableHeaderTop} style={{width: 120}}>ﾉｽﾞﾙ</TableCell>
                        <TableCell align={"center"} className={this.props.classes.tableHeaderTop} style={{width: 120}}>圧力</TableCell>
                        <TableCell align={"center"} className={this.props.classes.tableHeaderTop} style={{width: 80}}>開始</TableCell>
                        <TableCell align={"center"} className={this.props.classes.tableHeaderTop} style={{width: 80}}>停止</TableCell>
                        <TableCell align={"center"} className={this.props.classes.tableHeaderTop} style={{width: 80}}>完了</TableCell>
                        <TableCell align={"center"} className={this.props.classes.tableHeaderTop} style={{width: 170}}>開始時間</TableCell>
                        <TableCell align={"center"} className={this.props.classes.tableHeaderTop} style={{width: 170}}>完了時間</TableCell>
                        <TableCell align={"center"} className={this.props.classes.tableHeaderTop}>追加理由</TableCell>
                    </TableRow>
                    {ROWS.map((row, i) => {
                        // noinspection JSUnresolvedVariable
                        return (
                            <HeatExchangerCleaningRangeTableRow
                                key={i}
                                heatExchanger={this.props.heatExchanger}
                                cleaningRangeType={row.cleaningRangeType}
                                paramMapKey={row.paramMapKey}
                                onChangeConstructionMethod={this.onChangeConstructionMethod}
                                onChangeSpecification={this.onChangeSpecification}
                                onChangeNozzle={this.onChangeNozzle}
                                onChangePressure={this.onChangePressure}
                                onChangeStart={this.onChangeStart}
                                onChangeStop={this.onChangeStop}
                                onChangeComplete={this.onChangeComplete}
                                onChangeAdditionalReason={this.onChangeAdditionalReason}
                                isSpecificationTextField={row.isSpecificationTextField}
                                noSpecification={row.noSpecification}
                                noNozzle={row.noNozzle}
                                noPressure={row.noPressure}
                                specificationOption={row.specificationOption}
                            >
                                {row.children}
                            </HeatExchangerCleaningRangeTableRow>
                        )
                    })}
                </TableBody>
            </Table>
        );
    }
}

HeatExchangerCleaningRange.propTypes = {
    heatExchanger: PropTypes.object.isRequired,
    onChangeHeatExchanger: PropTypes.func.isRequired
};

export default withStyles(styles)(HeatExchangerCleaningRange);
